import React, { useContext } from 'react';
import useLeaveContracts from '@ubeya/shared/hooks/account/useLeaveContracts';
import ConfigContext from '../../../contexts/ConfigContext';

const NO_CONTRACT_ID = 0;

const LeaveContractsChip = ({ value }) => {
  const { t } = useContext(ConfigContext);
  const { mappedLeaveContracts = {} } = useLeaveContracts();
  const ids = Array.isArray(value) ? value : [value];

  const contractNames = ids
    .map((id) => {
      if (id === NO_CONTRACT_ID) {
        return t('none');
      }
      const contract = mappedLeaveContracts[id];
      if (!contract) return null;
      return contract.isDeleted ? `${contract.name} (${t('deleted')})` : contract.name;
    })
    .filter(Boolean)
    .join(', ');
  return <>{contractNames}</>;
};

export default LeaveContractsChip;
